import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./loginotp.css";
import OtpInput from "react-otp-input";
import { FiEyeOff } from "react-icons/fi";
import { BsArrowLeft, BsEye } from "react-icons/bs";
import { toast } from "react-toastify";
import {
  checkGuestUserService,
  CheckMemberService,
  LoginService,
  SendEmailService,
} from "../../API/loginApi";
import axiosConfig from "../../helper/axiosConfig";
import Spinner from "../Spinner";
import { generateToken } from "../commonFun";
import { isAuthenticated } from "../../utils/auth";
import loginImg from "../../assets/images/loginUI.svg";

const LoginOtp = ({ afterLogin, closeModal = () => {}, setIsAuthenticated, memberData }, props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {id} = useParams()
  // const isEventRegistrationForm = location.pathname.startsWith("/eventregisterationform");

  const branchid = localStorage.getItem("branchid");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [sendEmailCheck, setSendEmailCheck] = useState(false);
  const [generateOtp, setGenerateOtp] = useState();
  const [userData, setUserData] = useState({});
  const [formData, setFormData] = useState({
    email: "", // Static email ID
  });
  const [validMember, setValidMember] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [step, setStep] = useState(1); // Step state
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  async function checkMemberIsValid(email, branchid) {
    try {
      setLoading(true); // Start loading
      // const res = await CheckMemberService(email, branchid);
      const res = await checkGuestUserService(email);
      // console.log("res::: ", res?.data?.[0]);
      if (res?.data?.[0]?.category === "Prospect") {
        setUserData(res?.data?.[0]);
      } else {
        toast.warn("The guest you’re looking for does not exist.", { autoClose: 1500 });
      }
      setUserData(res?.data);
      if (
        res &&
        res?.status === 200 &&
        res?.data?.[0]?._id &&
        res?.data?.[0]?.category === "Prospect"
      ) {
        setValidMember(true);
        // const salutation = res?.data?.[0]?.property?.salutation ?? defaultValue;
        // const firstname = res?.data?.[0]?.property?.firstname ?? defaultValue;
        // const surname = res?.data?.[0]?.property?.surname ?? defaultValue;

        // let fullName = `${salutation} ${firstname} ${surname}`.trim();
        // if (fullName === `${defaultValue} ${defaultValue} ${defaultValue}`) {
        //   fullName = defaultValue;
        // }
        // localStorage.setItem("name", fullName);
        // localStorage.setItem("currency", res?.data?.[0]?.branchid?.currency);
        // localStorage.setItem("branchname", res?.data?.[0]?.branchid?.branchname);
        // localStorage.setItem("_authkey", res?.data?.[0]?._id);

        localStorage.setItem("fullname", res?.data?.[0]?.fullname);
        localStorage.setItem("LoginUserId", res?.data?.[0]?._id);
        localStorage.setItem("usertype", res?.data?.[0]?.category);
        localStorage.setItem("primaryemail", res?.data?.[0]?.property?.primaryemail);
        localStorage.setItem("fullname", res?.data?.[0]?.property?.fullname);
        localStorage.setItem("userData", JSON.stringify(res?.data?.[0]));

      } else {
        setValidMember(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("fetch Error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  }

  async function sendEmail(name, email, otp) {
    // console.log('name::: ', name);
    console.log("otp::: ", otp)
    try {
      setLoading(true); // Start loading
      const res = await SendEmailService(name, email, otp);
      if (res && res?.status === 200) {
        toast.success("OTP sent successfully", { autoClose: 1000 });
        setStep(2); // Move to next step
      } else {
        toast.error("Failed to send OTP", { autoClose: 1000 });
      }
    } catch (error) {
      setLoading(false);
      console.error("fetch Error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  }

  const validateForm = () => {
    let tempErrors = {
      email: "",
    };
    let isValid = true;

    if (!formData.email.trim()) {
      tempErrors.email = "Email ID is required";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleTermsChange = (e) => {
    setIsTermsAccepted(e.target.checked);
  };




  const handleNext = async (e) => {
    let email = formData?.email;
    e.preventDefault();
    if (validateForm()) {
      await checkMemberIsValid(email, branchid);

      setValidMember((prevValidMember) => {
        if (prevValidMember) {
          const verifyOtpNumber = Math.floor(1000 + Math.random() * 9000);
          setGenerateOtp(verifyOtpNumber);
          sendEmail(
            localStorage.getItem("fullname"),
            email,
            verifyOtpNumber
          );
        } else {
          // if (isEventRegistrationForm === true) {
          //   toast.error("Please register the event as Non-Member", {
          //     autoClose: 1500,
          //   });
          // } else {
          //   toast.error("Invalid user", { autoClose: 1000 });
          // }
        }
        return prevValidMember;
      });
    }
  };

  const handleBack = () => {
    setStep(1); // Move back to step 1
    setOtp(""); // Reset the OTP field
  };

  const handleResendOtpClick = async () => {
    const verifyOtpNumber = Math.floor(1000 + Math.random() * 9000);
    setGenerateOtp(verifyOtpNumber);
    sendEmail(
      localStorage.getItem("fullname"),
      formData.email,
      verifyOtpNumber
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isTermsAccepted) {
      toast.warning("Please accept terms and conditions", { autoClose: 1000 });
      return;
    }
    if (validateForm()) {
      if (otp?.length !== 4) {
        toast.error("Please enter a valid 4-digit OTP", { autoClose: 1000 });
        return;
      }
      let checkOtp = Number(generateOtp) === Number(otp);

      if (!checkOtp) {
        toast.error("Invalid OTP", { autoClose: 1000 });
        return;
      }

      const newToken = generateToken();
      localStorage.setItem("token", newToken);

      if (isAuthenticated()) {
        localStorage.setItem("LoginUserType", "Prospect");
        localStorage.setItem("Exist", "Prospect");
        console.log("User is authenticated. Navigating to dashboard...");
        setLoading(true);
        navigate(0)


        // setTimeout(() => {
        //   if (isEventRegistrationForm === true) {
        //     // const eventId = "someEventId"; // Replace with the actual event ID
        //     navigate(`/formeventticket/${id}`);
        //   } else {
        //     navigate("/dashboard");
        //   }
        //   setLoading(false);
        //   closeModal(); // Ensure closeModal is called safely
        // }, 1500);
      } else {
        setLoading(false);
        console.error("Authentication failed. Token might be invalid.");
      }
    }
  };

  // console.log('step::: ', step);

  return (
    <>
      {loading && <Spinner />}
      <div>
        <form
          onSubmit={step === 1 ? handleNext : handleSubmit}
          className={"loginOtp_form"}
        >
          {step === 1 && (
            <>
              <div>
                <img src={loginImg} alt="login_img" loading="lazy" />
              </div>
              <div className="loginOtp_inputGroup">
                <label htmlFor="email" className="loginOtp_label">
                  Email Id
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`loginOtp_input ${
                    errors.email ? "loginOtp_inputError" : ""
                  }`}
                  placeholder="Enter your email id"
                />
                {errors.email && (
                  <p className="loginOtp_errorText">{errors.email}</p>
                )}
                <button type="submit" className="loginOtp_submitButton mt-3">
                  Next
                </button>
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <div>
                <div className="otp_verification_ui">
                  <p className="mb-2">Verify your email address</p>
                  <p>
                  A verification code will be sent to your email address. Enter the code you receive in your inbox into the designated field. This code is a time-sensitive one-time password (OTP).
                    <br />
                  </p>
                </div>
              </div>
              <div className="otp_verification_ui ">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => (
                    <input {...props} className="loginOtp_otpInput " />
                  )}
                />

                <p className="loginOtp_resend ">
                  Don't receive the OTP ? <br /> Please check your spam folder
                  or <span onClick={handleResendOtpClick}> Resend</span>
                </p>
              </div>
              <div className="terms_conditions">
                <input
                  type="checkbox"
                  id="terms"
                  checked={isTermsAccepted}
                  onChange={handleTermsChange}
                />
                <label htmlFor="terms">
                I agree to the{" "}
                  <a
                    // href="https://cyberyouthaustralia.org.au/terms-of-use/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms & Conditions
                  </a>{" "}
                  and{" "}
                  <a
                    // href="https://cyberyouthaustralia.org.au/privacy-policy-2/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </label>
              </div>
              <button
                type="submit"
                className={`loginOtp_submitButton ${
                  isSubmitting ? "loginOtp_buttonLoading" : ""
                }`}
              >
                {isSubmitting ? "Logging in..." : "Log In"}
              </button>

              <div className="loginOtp_footer_content">
                <p onClick={handleBack}>Back to sign in</p>
              </div>
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default LoginOtp;
